import request from '@/utils/request'

const client_id = 'web'
const client_secret = '123456'
const scope = 'server'

// 登录方法
export function login(username, password, code, uuid) {
  return request({
    url: '/auth/login',
    method: 'post',
    data: {username, password, code, uuid }
  })
}
// 获取验证码的时候检查用户名密码
export function checkCode(username, password) {
  return request({
    url: '/auth/checkCode',
    method: 'post',
    data: { username, password}
  })
}
// 登陆的时候获取用户基本信息用于校验是否是首次登陆 或者是三个月未修改过密码
export function checkUserBaseInfo(params) {
  return request({
    url: '/system/user/baseInfo',
    method: 'get',
    params: params
  })
}
// 检查用户email是否一致
export function checkUserEmail(params) {
  return request({
    url:'/system/user/checkUserEmail',
    method:'get',
    params: params
  })
}
export function resetPwdByName(username, password,email) {
  return request({
    url: '/system/user/resetPwdByName',
    method: 'post',
    data: { userName:username,password:password,email:email}
  })
}
// 刷新方法
export function refreshToken() {
  return request({
    url: '/auth/refresh',
    method: 'post'
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/system/user/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'delete'
  })
}

// 获取验证码
export function getCodeImg(params) {
  return request({
    url: '/code',
    method: 'get',
    params:params
  })
}
